import axios from "@/utils/axios.js";

/**
 *
 * @param {object} params
 * 积分兑换页面中包含的信息：
 * {"agentTel":  经纪人电话 ,"integration":  积分}
 *
 */
export async function postScore(params) {
  let url = "/pointsLog/integrationToU";
  return axios.post(url, params);
}
/**
 * 获取积分
 * @param {object} params
 * {"agentID":经纪人ID}
 */
export async function getScore(params) {
  let url = "/pointsLog/getPointsLogNew";
  return axios.post(url, params);
}
